<template>
  <div class="su-page" :style="{background:bg}">
    <div class="mt15 su-page-content">
      <div class="leftNavigation mb20">
        <div
            class="leftNavigation-item flex al-cn"
            :style="{background:parentRoute2 == item.path ? '#F5F6F9' : '',color:parentRoute2 == item.path ? '#0066FF' : ''}"
            v-for="(item,index) in list"
            :key="index"
            @click="routerGo(item.path)">
          <div v-if="parentRoute2 == item.path" class="leftNavigation-leftIcon"/>
          <div class="f16 leftNavigation-item-name" :class="{clC32912:parentRoute2 == item.path}">
            {{ item.meta.title }}
          </div>
        </div>
      </div>
      <div class="mb20">
        <el-card class="rightData pt0">
          <div class="flex al-cn cl999 f13 pb20">
            当前位置：
            <div v-for="(item,index) in $route.matched" :key="index">
              <!--如果当前为倒数第二个并且最后一个没有值 或 当前为最后一个-->
              <div
                  v-if="(index == $route.matched.length - 2 &&
            !$route.matched[$route.matched.length - 1].meta.title) ||
            index == $route.matched.length - 1"
                  class="cl333 pointer discolour-blue1" @click="routerGo(item.path)">
                {{ item.meta.title }}
              </div>
              <div class="pointer discolour-blue1" v-else-if="item.meta.title" @click="routerGo(item.path)">
                {{ item.meta.title }}
                <i class="el-icon-arrow-right"/>
              </div>
            </div>
          </div>
          <div class="commonality-title">{{ title1 }}</div>
          <div class="borderTop pt30">
            <slot/>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
// 导入路由配置
import kejianrouter from '@/router';
import {logout} from "@/api/api";

export default {
  name: "su-page",
  props: {
    title: {
      type: String,
      default: ''
    },
    bg: {
      type: String,
      default: 'rgba(255,255,255,0)'
    }
  },
  data() {
    return {
      parentRoute: '', // 父级路由
      parentRoute2: '',
      parentRoute3: '',
      typeIndex: '', // 当前路由
      title1: this.title ? this.title : this.$route.meta.title,
      list: []
    };
  },
  mounted() {
    // console.log('组件页面')
    //字符串，用/分隔取第一个
    this.typeIndex = this.$route.fullPath
    let fullPath = this.$route.fullPath.split('/')
    this.parentRoute = fullPath[1]
    this.parentRoute2 = fullPath[2]
    if (fullPath[3]) {
      this.parentRoute3 = fullPath[3]
    }
    this.list = this.getAllRoutes(kejianrouter.options.routes[0].children, this.parentRoute)
  },
  methods: {
    // 路由跳转
    routerGo(path) {
      console.log('路由跳转', path)
      if (path == '') {
        this.$router.push({path: '/'});
      } else if (path == 'logOut') {
        //是否确认退出登录
        this.$confirm('确认要退出登录？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 退出登录
          logout().then(res => {
            if (res.code === 1) {
              this.$message.success('退出成功')
              //清除缓存
              this.$store.commit('logout')
              this.$router.push({name: 'login'})
            }
          })
        }).catch(() => {

        });
      } else if (
          !(this.$route.meta.title == '个人信息' && path == '/individualCenter') &&
          path !== "/" + this.parentRoute2 &&
          path !== "/" + this.parentRoute + "/" + this.parentRoute2) {
        this.$router.push({path: path});
      }
    },
    // 获取所有路由.处理数据
    getAllRoutes(routes = [], fullPath) {
      let allRoutes = [];
      routes.forEach(route => {
        if (route.path === fullPath) {
          allRoutes = route.children || [];
        }
      });
      return allRoutes;
    }
  }
}
</script>

<style lang="scss">
.su-page {
  box-sizing: border-box;
  width: 100%;
  line-height: 1.15;
  font-size: 16px;

  .leftNavigation {
    background: #fff;
    border-radius: 10px;

    &-leftIcon {
      width: 4px;
      height: 35px;
      background: #0066FF;
    }

    &-item {
      height: 50px;

      &-name {
        margin-left: 30px;
      }

      &:hover {
        cursor: pointer;
        background: #F5F6F9;
      }
    }
  }

  .rightData {
    padding: 10px 20px;
    min-height: 50vh;
  }
}

.su-page-content {
  grid-column-gap: 20px;
  display: grid;
  grid-template-columns: calc(20% - 10px) calc(80% - 10px);
}
</style>
